import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { HtmlElementHelper } from '@planone/bau365/util-fair-data';

import * as linkClickActions from './link-click.actions';
import { LinkClickEventType } from './link-click.models';

@Injectable()
export class LinkClickFacade {
  constructor(private readonly store: Store) {}

  trigger(linkClickEvent: LinkClickEventType) {
    this.store.dispatch(
      linkClickActions.linkClick({
        ...linkClickEvent,
        htmlElement: HtmlElementHelper.flattenObject(linkClickEvent.eventTarget) ?? undefined,
        eventTarget: undefined,
      })
    );
  }
}
